import React from "react";
import { Col, Flex, Form, Input, Row, Typography, Button } from "antd";
import { useTranslation } from "react-i18next";
import { colors } from "../../../../../../constants/colors";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { useState } from "react";
import { redeemeGiftCodeAction, validateGiftCodeAction } from "../../../../../../redux/services/wallet-info/walletInfoServices";
import { useDispatch, useSelector } from "react-redux";
import { getStaffSelectListAction } from "../../../../../../redux/services/staff/staffServices";
import useLocalStorage from "../../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../../constants/config/appConfig";
import { routes } from "../../../../../../constants";
import Actions from "../../../../../../redux/actions";
import { baseRouteMaker } from "../../../../../../constants/routeConsts";
import { useNavigate } from "react-router-dom";
import { sanitizeDataTypeClientSide } from "../../../../../../utils/utils";
import PurchaseGiftCardDialog from "./PurchaseGiftCardDialog";
import { CheckCircleFilled } from "@ant-design/icons";

const GiftCard = () => {
  let timeout = null;

  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [validateCouponCodeLoader, setValidateCouponCodeLoader] =
    useState(false);
  const [validateCouponLoader, setValidateCouponLoader] = useState(false);
  /* loading dependencies */

  /* navigate dependencies */
  const navigate = useNavigate();
  /* navigate dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  const {loginDetails} = useSelector(state => state.auth);
  const {validateGiftCodeData} = useSelector(state => state.giftCards);

  const [form] = Form.useForm();
  const gift_card_token = Form.useWatch("gift_card_token", {
    form,
    preserve: true,
  });

  const [couponCodeMessage, setCouponCodeMessage] = useState("");
  const [coupon_code, setCouponCode] = useState("");


  /* on submit */
  const onSubmit = (values) => {
    const dataToBeSent = {
      to_id:loginDetails?._id,
      amount: validateGiftCodeData?.amount,
      source:"GIFTCARD",
      payment_intent_id:null,
      gift_card_id:validateGiftCodeData?._id,
      gift_card_token
    };

    dispatch(redeemeGiftCodeAction(dataToBeSent, setLoading, form, setCouponCodeMessage));
  };
  /* on submit */

  const handleAddEditDetails = (e, row) => {
    navigate(baseRouteMaker(routes.PURCHASE_GIFT_CARD));
  };

  const onValidateCouponCode = () => {
    if (
      gift_card_token &&
      gift_card_token !== null &&
      gift_card_token !== "" &&
      gift_card_token !== undefined
    ) {
      const dataToBeSent = {
        gift_card_token: gift_card_token,
      };
      dispatch(
        validateGiftCodeAction(
          dataToBeSent,
          setValidateCouponCodeLoader,
          setCouponCodeMessage,
          form
        )
      );
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      autoComplete="off"
      requiredMark={false}
      onFinish={onSubmit}
    >
      <Flex vertical gap="1rem">
        <Flex justify="space-between">
          <Typography.Title level={3}>
            {t("Modules.WalletInfo.giftTitle")}
          </Typography.Title>
          <Button type="primary" onClick={(e) => handleAddEditDetails(e, null)}>
            {t("Modules.WalletInfo.purchaseGiftCard")}
          </Button>
        </Flex>
        <Row gutter={[24, 24]}>
          <Col span={16}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.WalletInfo.giftCode")}
                      required={false}
                    />
                  }
                  name="gift_card_token"
                  normalize={(value) => sanitizeDataTypeClientSide(value)}
                >
                  <Input
                    style={{
                      border:
                        couponCodeMessage !== "" &&
                        couponCodeMessage !== undefined &&
                        setCouponCodeMessage !== null
                          ? `1px solid ${colors.limeGreen}`
                          : "",
                    }}
                    placeholder={t("Modules.WalletInfo.pleaseEnterGiftCode")}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                </Form.Item>
              </Col>
              <Col
                span={5}
                style={{
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Button
                  type="primary"
                  loading={validateCouponCodeLoader}
                  style={{ width: "100%", marginTop: 10 }}
                  disabled={
                    validateCouponLoader ||
                    (couponCodeMessage !== "" &&
                      couponCodeMessage !== null &&
                      couponCodeMessage !== undefined)
                  }
                  onClick={(e) => onValidateCouponCode(e)}
                >
                  {couponCodeMessage !== "" &&
                  couponCodeMessage !== null &&
                  couponCodeMessage !== undefined
                    ? t("CommonUtils.applied")
                    : t("CommonUtils.apply")}
                </Button>
              </Col>
              <Col
                span={5}
                style={{
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Button
                  type="dashed"
                  loading={validateCouponCodeLoader}
                  style={{ width: "100%", marginTop: 10 }}
                  disabled={submitLoader}
                  onClick={() => {
                    setCouponCodeMessage("");
                    form.setFieldValue("gift_card_token", "");
                  }}
                >
                  {t("CommonUtils.clear")}
                </Button>
              </Col>
            </Row>
            {couponCodeMessage !== "" &&
              couponCodeMessage !== null &&
              couponCodeMessage !== undefined && (
                <Typography.Title
                  level={4}
                  style={{
                    color: `${colors.limeGreen}`,
                    margin: 0,
                    display: "flex",
                    gap: "0.3rem",
                  }}
                >
                  {couponCodeMessage}
                  <CheckCircleFilled style={{ fontSize: 16 }} />
                </Typography.Title>
              )}
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading || !couponCodeMessage}
            >
              {t("Modules.WalletInfo.redeem")}
            </Button>
          </Col>
        </Row>
      </Flex>
    </Form>
  );
};

export default GiftCard;
